import { Color, PerspectiveCamera, Vector3 } from "three";
import GPUParticles from "./GPUParticles/GPUParticles";

const TMP_COL = new Color();

const TMP_1 = new Vector3();
const TMP_2 = new Vector3();

const SPAWN_RATE_CAMERA = 1000; // per second
const SPAWN_RATE_AMBIENT = 300;
const SPAWN_RATE_INIT = SPAWN_RATE_AMBIENT * 14.5; // 14.5 is the average lifespan

class AmbientParticles {
  private particleSystem: GPUParticles;
  private camera: PerspectiveCamera;

  constructor(particleSystem: GPUParticles, camera: PerspectiveCamera) {
    this.particleSystem = particleSystem;
    this.camera = camera;

    for (let i = 0; i < SPAWN_RATE_INIT; i++) {
      const lifespan = 12 + Math.random() * 5;
      this.particleSystem.spawnParticle({
        position: new Vector3(
          Math.random() * 30 - 15,
          0,
          Math.random() * 30 - 15
        ),
        spread: 0,
        velocity: new Vector3(0, 1, 0),
        velocityRandomness: 0.2,
        lifespan,
        startTimeOffset: Math.random() * lifespan,
        color: TMP_COL.set(Math.random() * 0xffffff),
        speed: 1 + Math.random() * 1,
      });
    }
  }

  public update(delta: number, cameraSpeed: number): void {
    const spawnCountCamera = (SPAWN_RATE_CAMERA / 60) * delta * cameraSpeed;
    TMP_1.copy(this.camera.position);
    this.camera.getWorldDirection(TMP_2);
    TMP_2.multiplyScalar(2);
    TMP_1.add(TMP_2);
    for (let i = 0; i < spawnCountCamera; i++) {
      this.particleSystem.spawnParticle({
        position: new Vector3(TMP_1.x, TMP_1.y * 0.75, TMP_1.z),
        spread: 2,
        velocity: TMP_2.negate(),
        velocityRandomness: 1,
        lifespan: 1 + Math.random(),
        color: TMP_COL.set(Math.random() * 0xffffff),
        speed: 7 + Math.random() * 3,
      });
    }

    const spawnCountAmbient = (SPAWN_RATE_AMBIENT / 60) * delta;
    for (let i = 0; i < spawnCountAmbient; i++) {
      this.particleSystem.spawnParticle({
        position: new Vector3(
          Math.random() * 30 - 15,
          0,
          Math.random() * 30 - 15
        ),
        spread: 0,
        velocity: new Vector3(0, 1, 0),
        velocityRandomness: 0.2,
        lifespan: 12 + Math.random() * 5,
        color: TMP_COL.set(Math.random() * 0xffffff),
        speed: 1 + Math.random() * 1,
      });
    }
  }
}

export default AmbientParticles;
